import script from "./OurLossesCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OurLossesCard.vue?vue&type=script&setup=true&lang=js"

import "./OurLossesCard.vue?vue&type=style&index=0&id=7d09be5d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d09be5d"]])

export default __exports__